// extracted by mini-css-extract-plugin
module.exports = {"nav":"xI","fixedNav":"xJ","navRight":"xK","navLinkLogo":"xL","navLink":"xM","navLinkActive":"xN","isRental":"xO"};